export const generateCardYears = (
  valueFormat: 'YYYY' | 'YY',
): { value: string; label: string }[] => {
  const currentYear = new Date().getFullYear();
  const yearArray = [];

  for (let i = 0; i <= 10; i++) {
    const year = currentYear + i;

    const yearObject = {
      value: valueFormat === 'YY' ? String(year).substring(2) : String(year),
      label: String(year),
    };

    yearArray.push(yearObject);
  }

  return yearArray;
};

export function normalizeExpirationDateValue(
  value: string,
  yearFormat?: 'YY' | 'YYYY',
): string {
  if (!value || yearFormat === 'YY') return value;
  const mmYyMatch = /^(\d{2})\/(\d{2})$/.exec(value);
  if (mmYyMatch) {
    const [, month, yy] = mmYyMatch;
    return `${month}/20${yy}`;
  }
  return value;
}
